import { Link } from "react-router-dom";
import { AuthShell } from "./AuthShell";
import { ResetUnavailable } from "./Forgot";

export default function Reset() {
  return (
    <AuthShell
      title="Set a new password"
      footer={<Link to="/login" className="font-semibold text-emerald-600 hover:underline" data-testid="back-to-login">Back to sign in</Link>}
    >
      <ResetUnavailable />
    </AuthShell>
  );
}
